export const getYleTunnusState = state => state.yleTunnus
export const getLoggedInState = state => state.yleTunnus.userId !== null
